import React from 'react';
import { phaseLabel } from '../../../utils/casinoSeatLayout';

/**
 * Center felt stage: pot + phase focal point + hand-result banner.
 */
export default function CenterStage({
  pot = 0,
  creditValue = 1,
  phase,
  result = null,
}) {
  const dollars = (Number(pot || 0) * Number(creditValue || 1)).toFixed(2);
  const showResult = !!(result && result.visible);

  return (
    <div className="cv2-center-stage">
      {showResult ? (
        <div
          className={`cv2-result-banner cv2-result-${result.kind || 'win'}`}
          role="status"
          aria-live="polite"
        >
          <div className="cv2-result-title">{result.title}</div>
          {result.subtitle && (
            <div className="cv2-result-subtitle">{result.subtitle}</div>
          )}
          {result.earnings > 0 && (
            <div className="cv2-result-earnings">
              +{result.earnings} chips
              {result.dollars != null ? ` · $${result.dollars}` : ''}
            </div>
          )}
        </div>
      ) : (
        <div className="cv2-pot">
          <div className="cv2-pot-label">Pot</div>
          <div className="cv2-pot-value">{pot || 0} chips</div>
          <div className="cv2-pot-money">${dollars}</div>
        </div>
      )}
      {phase && !showResult && (
        <div className="cv2-phase-pill">{phaseLabel(phase)}</div>
      )}
      {phase && showResult && (
        <div className="cv2-phase-pill">{phaseLabel(phase)}</div>
      )}
    </div>
  );
}
